"use client"

import { EPageName } from "@/util/enum"
import SingleSwiper from "@/components/ui/swiper/SingleSwiper"
import SingleImageCard from "@/components/ui/cardSection/SingleImageCard"
import { useIsMobile } from "@/components/ui/hooks/useIsMobile"

interface BeforeAfterSwiperItem {
    imageUrl: string,
    alt_name: string,
}

interface BeforeAfterSwiperProps {
    crouselData: BeforeAfterSwiperItem[]
}

const BeforeAfterSwiper = ({ crouselData }: BeforeAfterSwiperProps) => {

    const checkIsMobile = useIsMobile();

    return (
        <div className="w-full mt-2.5 px-0 md:px-2 lg:px-20">
            <SingleSwiper pageName={(crouselData?.length<2 && checkIsMobile)?EPageName.BANNER :EPageName?.THREESLIDE} crouselData={crouselData} renderItem={(item) => (
                <SingleImageCard
                    imageUrl={item.imageUrl}
                    imageName={item.alt_name}
                />
            )} />
        </div>
    )
}

export default BeforeAfterSwiper
